interface RosterColumnHeaderContext {
  column: {
    getCanSort: () => boolean;
    getToggleSortingHandler: () =>
      | ((event: React.MouseEvent<HTMLButtonElement>) => void)
      | undefined;
  };
}

export const rosterColumnHeader =
  (label: string) =>
  ({ column }: RosterColumnHeaderContext) => {
    const content = (
      <span className="min-w-0 flex-1 whitespace-normal leading-tight [overflow-wrap:anywhere]">
        {label}
      </span>
    );

    if (!column.getCanSort()) return content;

    return (
      <button
        type="button"
        className="min-w-0 max-w-full rounded text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={(event) => {
          event.stopPropagation();
          column.getToggleSortingHandler()?.(event);
        }}
      >
        {content}
      </button>
    );
  };
